<vng-select
  #select
  [label]="label"
  [placeholder]="placeholder"
  [formControl]="control"
  [options]="options"
  [searchable]="true"
  [error]="error"
  (selectionChange)="selectionChange.emit($event)"
>
  <ng-template #vngSelectActions>
    <!-- No <vng-divider> here: vng-select's own `.vng-select__actions` band
         already draws a border-top, so the divider rendered a second rule 8px
         below the first. -->
    <div class="sticky-option" *ngIf="canCreate && !hasExactCategoryMatch(select.searchQuery)">
      <div class="option-btn" (click)="onCreate(select.searchQuery)" *ngIf="select.searchQuery">
        <span>"{{ select.searchQuery }}"</span> (Create New Category)
      </div>
      <div class="option-btn" (click)="onCreate('')" *ngIf="!select.searchQuery">
        {{ createLabel }}
      </div>
    </div>
  </ng-template>
</vng-select>
